import { getAuthToken } from "../context/auth-context";
import { CALL_API } from "../context/constValues";
import Swal from "sweetalert2";
export async function getAllPaciente() {
  const token = getAuthToken();
  const response = await fetch(`${CALL_API}/paciente`, {
    headers: { Authorization: "Bearer " + token },
  });

  const data = await response.json();
  if (!response.ok) {
    throw new Error("No se encontraron datos");
  }

  return data.result;
}

export async function getPacientesById(idPaciente) {
  const token = getAuthToken();
  const response = await fetch(`${CALL_API}/paciente/${idPaciente}`, {
    headers: { Authorization: "Bearer " + token },
  });

  const data = await response.json();
  if (!response.ok) {
    throw new Error("Can not fetch the data with this parameter");
  }

  return data.result;
}
export async function getSignosVitalesbyLegajo(id) {
  const token = getAuthToken();
  const response = await fetch(`${CALL_API}/signosvitalesbyLegajo/${id}`, {
    headers: { Authorization: "Bearer " + token },
  });

  const data = await response.json();
  if (!response.ok) {
    throw new Error("No se encontraron datos");
  }

  return data.result;
}
export async function getSearchPaciente(sqlSearch) {
  const token = getAuthToken();
  const response = await fetch(`${CALL_API}/paciente?sqlSearch=${sqlSearch}`, {
    headers: { Authorization: "Bearer " + token },
  });

  const data = await response.json();

  if (!response.ok) {
    throw new Error("Can not fetch the data with this parameter");
  }

  return data.result;
}

export async function getLocal() {
  const token = getAuthToken();
  const response = await fetch(`${CALL_API}/local`, {
    headers: { Authorization: "Bearer " + token },
  });

  const data = await response.json();

  if (!response.ok) {
    throw new Error("Can not fetch the data with this parameter");
  }

  return data.result;
}

export async function getPacienteByProfesional(IdProfesional) {
  const token = getAuthToken();
  const response = await fetch(
    `${CALL_API}/paciente/profesional/${IdProfesional}`,
    {
      headers: { Authorization: "Bearer " + token },
    }
  );

  const data = await response.json();

  if (!response.ok) {
    throw new Error("Can not fetch the data with this parameter");
  }

  return data.result;
}

export async function insertPaciente(pacienteObject) {
  const {
    nombre,
    apellido,
    fechadenacimiento,
    ci,
    edad,
    sexo,
    responsable,
    ciresponsable,
    ruc,
    razonsocial,
    correo,
    telefono,
    nresponsable,
    ciudad,
    direccion,
    peso,
    altura,
    diagnosticomedico,
    enfermedadesdebase,
    mpropia,
    equipoderehabilitacion,
    formadealimentacion,
    tiempodeasistencia,
    hs,
    direccionserv,
    alergiasamedicamentos,
    alergiasgral,
    comoconocio,
    obs1,
    obs2,
    viadealimentacion,
    definiralergia,
    definiralergiasgral,
    tarifa,
    nivel,
  } = pacienteObject;


  const token = getAuthToken();
  const response = await fetch(`${CALL_API}/paciente`, {
    method: "POST",
    headers: {
      Authorization: "Bearer " + token,
      "Content-Type": "application/json",
    },
    body: JSON.stringify({
      alergiasamedicamentos: alergiasamedicamentos,
      alergiasgral: alergiasgral,
      comoconocio: comoconocio,
      obs1: obs1,
      obs2: obs2,
      viadealimentacion: viadealimentacion,
      Nombre: `${nombre} ${apellido}`,
      FechaNacimiento: fechadenacimiento,
      Cedula: ci,
      Edad: edad,
      Sexo: sexo,
      FamiliarResponsable: responsable,
      CedulaResponsable: ciresponsable,
      Ruc: ruc,
      Razonsocia: razonsocial,
      Correo: correo,
      Telefono: telefono,
      Celular: nresponsable,
      Ciudad: ciudad,
      Direccion: direccion,
      Peso: peso,
      Altura: altura,
      DiagnosticoMedico: diagnosticomedico,
      EnfermedadBase: enfermedadesdebase,
      MovilidadPropia: mpropia,
      EquipoRehabilitacion: equipoderehabilitacion,
      FormaAlimentacion: formadealimentacion,
      TiempoAsistencia: tiempodeasistencia,
      Direccionserv: direccionserv,
      Guardiahs: hs,
      tarifa: tarifa,
      nivel: nivel,
    }),
  });
  const data = await response.json();

  if (!response.ok) {
    throw new Error(data.message);
  }

  return data.isSaved;
}

export async function updatePaciente(pacienteObject) {
  const {
    NombrePaciente,
    FechaNacimiento,
    Cedula,
    Edad,
    Sexo,
    FamiliarResponsable,
    CedulaResponsable,
    Ruc,
    RazonSocial,
    Correo,
    Telefono,
    Celular,
    Ciudad,
    Direccion,
    peso,
    altura,
    diagnosticoMedico,
    enfermedadBase,
    movilidadPropia,
    equipoRehabilitacion,
    formaAlimentacion,
    tiempoAsistencia,
    Guardiahs,
    Direccionserv,
    IdPacientes,
    comoconocio,
    obs1,
    obs2,
    viadealimentacion,
    alergiasamedicamentos,
    alergiasgral,
    definiralergia,
    definiralergiasgral,
    tarifa,
    nivel,
  } = pacienteObject;

  const token = getAuthToken();
  const response = await fetch(`${CALL_API}/paciente/updatepaciente`, {
    method: "POST",
    headers: {
      Authorization: "Bearer " + token,
      "Content-Type": "application/json",
    },
    body: JSON.stringify({
      Nombre: NombrePaciente,
      FechaNacimiento: FechaNacimiento,
      Cedula: Cedula,
      Edad: Edad,
      Sexo: Sexo,
      FamiliarResponsable: FamiliarResponsable,
      CedulaResponsable: CedulaResponsable,
      Ruc: Ruc,
      Razonsocial: RazonSocial,
      Correo: Correo,
      Telefono: Telefono,
      Celular: Celular,
      Ciudad: Ciudad,
      Direccion: Direccion,
      Peso: peso,
      Altura: altura,
      DiagnosticoMedico: diagnosticoMedico,
      EnfermedadBase: enfermedadBase,
      MovilidadPropia: movilidadPropia,
      EquipoRehabilitacion: equipoRehabilitacion,
      FormaAlimentacion: formaAlimentacion,
      TiempoAsistencia: tiempoAsistencia,
      Direccionserv: Direccionserv,
      Guardiahs: Guardiahs,
      idPacientes: IdPacientes,
      comoconocio: comoconocio,
      obs1: obs1,
      obs2: obs2,
      viadealimentacion: viadealimentacion,
      alergiasamedicamentos: alergiasamedicamentos,
      alergiasgral: alergiasgral,
      definiralergia: definiralergia,
      definiralergiasgral: definiralergiasgral,
      tarifa: tarifa,
      nivel: nivel,
    }),
  });
  const data = await response.json();
  if (!response.ok) {
    throw new Error(`${data.message}`);
  }

  return data.isSaved;
}
export async function updatecuentacliente(pacienteObject) {
  const { data1, data2, data3 ,data4 } = pacienteObject;
  const token = getAuthToken();
  const response = await fetch(`${CALL_API}/updatecuentacliente`, {
    method: "POST",
    headers: {
      Authorization: "Bearer " + token,
      "Content-Type": "application/json",
    },
    body: JSON.stringify({
      id: data1,
      estadocuenta: data2,
      pass: data3,
      user:data4
    }),
  });
  const data = await response.json();
  if (!response.ok) {
    throw new Error(`${data.message}`);
  }

  return data.isSaved;
}
export async function deletePaciente(idPaciente) {
  const token = getAuthToken();
  const response = await fetch(`${CALL_API}/paciente/${idPaciente}`, {
    method: "DELETE",
    headers: { Authorization: "Bearer " + token },
  });

  const data = await response.json();

  if (!response.ok) {
    throw new Error("Can not fetch the data with this parameter");
  }

  return data.isDeleted;
}

export async function EstadoPaciente(usuarioObject) {
  const { id, motivo } = usuarioObject;
  const token = getAuthToken();
  const response = await fetch(`${CALL_API}/updateEstadoPaciente`, {
    method: "POST",
    headers: {
      Authorization: "Bearer " + token,
      "Content-Type": "application/json",
    },
    body: JSON.stringify({
      idpaciente: id,
      motivo: motivo,
    }),
  });
  const data = await response.json();
  if (!response.ok) {
    Swal.fire({
      title: "Error!",
      text: `${data.messege}`,
      icon: "error",
      confirmButtonText: "Ok",
    });
    throw new Error("Can not sign up this user");
  }
  return data;
}
export async function getAllSignosVitales() {
  const token = getAuthToken();
  const response = await fetch(`${CALL_API}/allsignosvitales`, {
    headers: { Authorization: "Bearer " + token },
  });

  const data = await response.json();

  if (!response.ok) {
    throw new Error(data.message);
  }
  return data.result;
}
export async function getEgresos(idlegajo) {
  const token = getAuthToken();
  const response = await fetch(`${CALL_API}/getegresos/${idlegajo}`, {
    method: "GET",
    headers: {
      Authorization: "Bearer " + token,
      "Content-Type": "application/json",
    },
  });

  const data = await response.json();
  if (!response.ok) {
    throw new Error(data.message);
  }

  return data.result;
}
export async function getIngresos(idlegajo) {
  const token = getAuthToken();
  const response = await fetch(`${CALL_API}/getingresos/${idlegajo}`, {
    method: "GET",
    headers: {
      Authorization: "Bearer " + token,
      "Content-Type": "application/json",
    },
  });
  const data = await response.json();
  if (!response.ok) {
    throw new Error(data.message);
  }

  return data.result;
}

// recetario

export async function getRecetarioByPaciente(idpaciente) {
  const token = getAuthToken();
  const response = await fetch(`${CALL_API}/recetariopaciente/${idpaciente}`, {
    headers: { Authorization: "Bearer " + token },
  });

  const data = await response.json();
  if (!response.ok) {
    throw new Error("Can not fetch the data with this parameter");
  }

  return data.result;
}
export async function insertReceta(objeto) {
  const { medicamento, dosis, cantdosis, doctor, registro, idpaciente } = objeto;
  const token = getAuthToken();
  const response = await fetch(`${CALL_API}/insertreceta`, {
    method: "POST",
    headers: {
      Authorization: "Bearer " + token,
      "Content-Type": "application/json",
    },
    body: JSON.stringify({
      medicamento,
      dosis,
      cantdosis,
      doctor,
      registro,
      idpaciente
    }),
  });
  const data = await response.json();
  if (!response.ok) {
    throw new Error(`${data.message}`);
  }

  return data.isSaved;
}
export async function updateReceta(objeto) {
  const {
    idreceta,
    medicamento,
    dosis,
    cantdosis,
    cantdosisactual,
    doctor,
    registro,
    idpaciente
  } = objeto;

  const token = getAuthToken();
  const response = await fetch(`${CALL_API}/updatereceta`, {
    method: "POST",
    headers: {
      Authorization: "Bearer " + token,
      "Content-Type": "application/json",
    },
    body: JSON.stringify({
      idreceta,
      medicamento,
      dosis,
      cantdosis,
      cantdosisactual,
      doctor,
      registro,
      idpaciente
    }),
  });
  const data = await response.json();
  if (!response.ok) {
    throw new Error(`${data.message}`);
  }

  return data.isSaved;
}

// usoInsumo

export async function getUsoInsumosByPaciente(idpaciente) {
  const token = getAuthToken();
  const response = await fetch(`${CALL_API}/usoinsumopaciente/${idpaciente}`, {
    headers: { Authorization: "Bearer " + token },
  });

  const data = await response.json();
  if (!response.ok) {
   if (!response.ok) {
    throw new Error(`${data.message}`);
  }
  }

  return data.result;
}
export async function insertUsoInsumo(objeto) {
  const { insumo, cantidad, cantidadtotal, cantidadactual, idpaciente,encargado} = objeto;
  const token = getAuthToken();
  const response = await fetch(`${CALL_API}/insertusoinsumo`, {
    method: "POST",
    headers: {
      Authorization: "Bearer " + token,
      "Content-Type": "application/json",
    },
    body: JSON.stringify({
      insumo,
      cantidad,
      cantidadtotal,
      cantidadactual,
      encargado,
      idpaciente
    }),
  });
  const data = await response.json();
 if (!response.ok) {
    throw new Error(`${data.message}`);
  }

  return data.isSaved;
}
export async function updateUsoInsumo(objeto) {
  const {
    idusoinsumo,
    insumo,
    cantidad,
    cantidadtotal,
    cantidadactual,
    encargado,
    idpaciente
  } = objeto;

  const token = getAuthToken();
  const response = await fetch(`${CALL_API}/updateusoinsumo`, {
    method: "POST",
    headers: {
      Authorization: "Bearer " + token,
      "Content-Type": "application/json",
    },
    body: JSON.stringify({
      idusoinsumo,
      insumo,
      cantidad,
      cantidadtotal,
      cantidadactual,
      encargado,
      idpaciente
    }),
  });
  const data = await response.json();
  if (!response.ok) {
    throw new Error(`${data.message}`);
  }

  return data.isSaved;
}
// tareas
export async function getTareaByPaciente(idpaciente) {
  const token = getAuthToken();
  const response = await fetch(`${CALL_API}/tareapaciente/${idpaciente}`, {
    headers: { Authorization: "Bearer " + token },
  });

  const data = await response.json();
  if (!response.ok) {
    throw new Error("Can not fetch the data with this parameter");
  }

  return data.result;
}
export async function insertTarea(objeto) {
  const { tarea, fecha, hora, idpaciente } = objeto;
  const token = getAuthToken();
  const response = await fetch(`${CALL_API}/inserttarea`, {
    method: "POST",
    headers: {
      Authorization: "Bearer " + token,
      "Content-Type": "application/json",
    },
    body: JSON.stringify({
      tarea,
      fecha,
      hora,
      idpaciente
    }),
  });
  const data = await response.json();
  if (!response.ok) {
    throw new Error("Can not fetch the data with this parameter");
  }

  return data.isSaved;
}
export async function updateTarea(objeto) {
  const {
    idtarea,
    tarea,
    fecha,
    hora,
    idpaciente
  } = objeto;

  const token = getAuthToken();
  const response = await fetch(`${CALL_API}/updatetarea`, {
    method: "POST",
    headers: {
      Authorization: "Bearer " + token,
      "Content-Type": "application/json",
    },
    body: JSON.stringify({
      idtarea,
      tarea,
      fecha,
      hora,
      idpaciente
    }),
  });

  const data = await response.json();
  if (!response.ok) {
    throw new Error(`${data.message}`);
  }

  return data.isSaved;
}
export async function deleteTarea(idtarea) {
  const token = getAuthToken();
  const response = await fetch(`${CALL_API}/tarea/${idtarea}`, {
    method: "DELETE",
    headers: { Authorization: "Bearer " + token },
  });

  const data = await response.json();
  if (!response.ok) {
    throw new Error("Can not fetch the data with this parameter");
  }

  return data.isDeleted;
}
export async function getTareas() {
  const token = getAuthToken();
  const response = await fetch(`${CALL_API}/tareasPacientebydate/`, {
    headers: { Authorization: "Bearer " + token },
  });

  const data = await response.json();
  if (!response.ok) {
    throw new Error("Error al traer datos");
  }
  return data.result;
}
export async function getTareaByPacienteandDate(objeto) {
  const token = getAuthToken();
   const {
   idpaciente,
   fecha
  } = objeto;
  const response = await fetch(`${CALL_API}/tareasPacientebyDateandPaciente`, {
    method: "POST",
    headers: {
      Authorization: "Bearer " + token,
      "Content-Type": "application/json",
    },
    body: JSON.stringify({
     idpaciente,
     fecha
    }),
  });

  const data = await response.json();
  if (!response.ok) {
    throw new Error("Can not fetch the data with this parameter");
  }

  return data.result;
}

/**
 * Descarga un archivo desde la API y lo guarda usando Tauri.
 * @param {string} url - URL del archivo a descargar
 * @param {string} defaultFileName - Nombre sugerido para el archivo
 * @param {Object} options - Opciones para el diálogo de guardado
 * @returns {Promise<string|null>} - Ruta donde se guardó el archivo o null si se canceló
 */
export async function downloadFileFromApi(url, defaultFileName, options = {}) {
  try {
    // Importar el helper de Tauri
    const { saveArrayBufferToDisk } = await import("../jsx/utils/tauriFileSave");
    
    const token = getAuthToken();
    const response = await fetch(url, {
      headers: { Authorization: "Bearer " + token },
    });

    if (!response.ok) {
      throw new Error("Error al descargar el archivo");
    }

    // Obtener el contenido como ArrayBuffer
    const arrayBuffer = await response.arrayBuffer();

    // Guardar usando Tauri
    return await saveArrayBufferToDisk(arrayBuffer, defaultFileName, options);
  } catch (error) {
    console.error("Error en downloadFileFromApi:", error);
    Swal.fire({
      title: "Error!",
      text: `Error al descargar archivo: ${error.message}`,
      icon: "error",
      confirmButtonText: "Ok",
    });
    throw error;
  }
}